module.exports = __webpack_public_path__ + "pic/8.0070d3f2.png";